import { render } from "./CitiesPage.vue?vue&type=template&id=2554a628&scoped=true"
import script from "./CitiesPage.vue?vue&type=script&lang=js"
export * from "./CitiesPage.vue?vue&type=script&lang=js"

import "./CitiesPage.vue?vue&type=style&index=0&id=2554a628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2554a628"]])

export default __exports__